import Request from "network/request";
import NetworkCall from "../../network/networkCall";

export class Terms {
  static async getUrl(useLoading = true) {
    return NetworkCall.fetch(Request.v2.getTermsOfUseUrl(), useLoading);
  }

  static async accept(useLoading = true) {
    return NetworkCall.fetch(Request.v2.acceptTermsOfUse(), useLoading);
  }
}
